import { intercept } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { Prompt } from 'react-router';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, Row } from 'reactstrap';
import ModalFooter from 'reactstrap/lib/ModalFooter';
import ModalHeader from 'reactstrap/lib/ModalHeader';
import DataTable from 'src/Components/DataTable';
import { IList } from 'src/Components/DataTable/DataTable';
import OpenArrow from 'src/Components/OpenArrow/OpenArrow';
import { IOperator, IRegion } from 'src/Interfaces/WellInterface';
import { AdminStore } from 'src/Stores/Admin/AdminStore';
import { MessageStore } from 'src/Stores/Messages/Messages';
import { UserStore } from 'src/Stores/User/UserStore';
import DeepCopy from 'src/UtilityFunctions/DeepCopy';
import { allOrNoneSelected, allOrNoneSelectedInternalProp, selectAllOrNone, selectAllOrNoneInternalProp } from 'src/UtilityFunctions/SelectAllOrNone';
import { GroupEmail, IOperatorRegionExpensePrice, IOperatorRegionPrice, IRegionExpensePrice, IRegionProductPrice, IWellList } from '../../../../Interfaces/AdminInterface';
import ButtonRow from '../../../ButtonRow';
import { EButton, EInput } from '../../../EInput';



@inject('stores')
@observer
class AdminOperatorDetails extends React.Component {

    public props: any;
    public operator: IOperator = new IOperator();
    public effectiveDate: IOperatorRegionPrice = new IOperatorRegionPrice();
    public modalOPL: IOperatorRegionPrice[] = [];
    public modalOPE: IOperatorRegionExpensePrice[] = [];
    public operatorDisposer: () => void;
    public operatorPriceDisposer: () => void;
    public operatorExpenseDisposer: () => void;
    public regionPriceDisposer: () => void;
    public regionExpenseDisposer: () => void;
    public wellListDisposer: () => void;
    public adminStore: AdminStore;
    public MessageStore: MessageStore;
    private UserStore: UserStore;
    // private TenantStore: TenantStore;
    public well: IWellList = new IWellList();


    private operatorPricesHeader = [
        "Product Name",
        "Primary Category",
        "Taxable",
        "Size",
        "Unit",
        "Specific Gravity",
        "Weight",
        "Cost",
        "Price",
        "Effecitve Date"
    ];

    private operatorExpenseHeader = [
        "Name",
        "Type",
        "Taxable",
        "Cost",
        "Price",
    ];

    private operatorGroupEmailHeader = [
        "Group Email",
        "Description",
    ];

    private operatorWellsHeader = [
        "Operator Region Wells",
        "Effective Product Lists",
        "Well Status"
    ];


    private operatorRegionHeaderButtons: any;
    private operatorPriceHeaderButtons: any;
    private operatorExpenseHeaderButtons: any;
    // private operatorExportHeaderButtons: any;

    public state = {
        downloadSelected: 'products',
        editing: false,
        editingGroupEmail: false,
        effectiveDate: this.effectiveDate,
        groupEmail: new GroupEmail(),
        groupEmailModal: false,
        isDirty: false,
        modal: false,
        modalOpe: this.modalOPE,
        modalOpl: this.modalOPL,
        operator: this.operator,
        operatorExpenseData: { headers: this.operatorExpenseHeader, rows: [] } as IList,
        operatorExpensePrices: {} as Record<string, IOperatorRegionExpensePrice[]>,
        operatorId: '',
        operatorPrices: {} as Record<string, IOperatorRegionPrice[]>,
        operatorRegionData: { headers: this.operatorPricesHeader, rows: [] } as IList,
        priceListOpen: [] as boolean[],
        redirect: false,
        region: new IRegion(),
        regionExpenses: [] as IRegionExpensePrice[],
        regionId: '',
        regionPrices: [] as IRegionProductPrice[],
        regions: [] as IRegion[],
        rowIndex: 0,
        selectedEbp: [] as boolean[],
        selectedProducts: [] as boolean[],
        selectedRegions: [] as boolean[],
        showDownloadModal: false,
        showExpenses: false,
        showPriceListModal: false,
        showProducts: false,
        showRegionModal: false,
        showWellListModal: false,
        well: this.well,
        wellList: [] as IWellList[],
        wellListData: { headers: this.operatorWellsHeader, rows: [] } as IList,
    };

    constructor(props: any, key: string) {
        super(props);

        this.adminStore = this.props.stores.AdminStore;
        this.MessageStore = this.props.stores.MessageStore;
        this.UserStore = this.props.stores.UserStore;
        // this.TenantStore = this.props.stores.TenantStore;
        this.initializeHeaders(key);
    }

    public componentDidMount() {
        this.createDisposers();

        this.adminStore.getRegions()
            .then(regions => {
                this.setState({
                    operatorId: this.props.match.params.id,
                    regions,
                }, () => {
                    if (this.state.operatorId !== 'new') {
                        this.adminStore.getOperator(this.props.match.params.id);
                    }
                });
            });
    }

    private initializeHeaders = (key: string) => {
        this.operatorPriceHeaderButtons = [
            undefined,
            undefined,
            {
                content: this.renderTaxableHeader('operatorPrices', key),
                type: 'render'
            },
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
        ];

        this.operatorExpenseHeaderButtons = [
            undefined,
            undefined,
            {
                content: this.renderTaxableHeader('operatorExpensePrices', key),
                type: 'render'
            },
            undefined,
            undefined,
        ];

        this.operatorRegionHeaderButtons = [
            {
                content: this.renderRegionSelectHeader,
                type: 'render'
            },
            undefined,
            undefined,
        ];
    }

    private renderRegionSelectHeader = () => {
        return (
            <div>
                <Button
                    color="primary"
                    outline={!this.allOrNoneSelectedRegions(true)}
                    onClick={this.selectAllOrNoneRegions(true)}
                >
                    All
                </Button>
                {' '}
                <Button
                    color="primary"
                    outline={!this.allOrNoneSelectedRegions(false)}
                    onClick={this.selectAllOrNoneRegions(false)}
                >
                    None
                </Button>
            </div>);
    }

    private renderTaxableHeader = (listName: string, key: string) => () => {
        return (
            <div>
                <Button
                    color="primary"
                    outline={!this.allOrNoneSelectedPrices(true, listName, 'isTaxable', key)}
                    onClick={this.selectAllOrNonePrices(true, listName, 'isTaxable', key)}
                >
                    All
                </Button>
                {' '}
                <Button
                    color="primary"
                    outline={!this.allOrNoneSelectedPrices(false, listName, 'isTaxable', key)}
                    onClick={this.selectAllOrNonePrices(false, listName, 'isTaxable', key)}
                >
                    None
                </Button>
            </div>
        );
    }

    public componentWillUnmount() {
        this.clearDisposers();
    }
    public setSelectedRegions = (operator: IOperator) => {
        const selectedRegions = [] as boolean[];
        operator.regions.forEach(region => {
            const index = this.state.regions.findIndex(reg => reg.id === region.id);
            selectedRegions[index] = true;
        });
        return selectedRegions;
    }

    public createDisposers() {
        this.operatorDisposer = intercept(this.adminStore, 'operator', (change: any) => {
            const selectedRegions = this.setSelectedRegions(change.newValue);
            this.setState({
                operator: change.newValue,
                selectedRegions
            });

            return change;
        });

        this.operatorPriceDisposer = intercept(this.adminStore, 'operatorProductPrices', (change: any) => {
            this.setState({
                operatorPrices: change.newValue,
            });
            return change;
        });

        this.wellListDisposer = intercept(this.adminStore, 'wellList', (change: any) => {
            this.setState({
                wellList: change.newValue
            }, () => {
                this.formatOperatorWellData();
            });
            return change;
        });

        this.operatorExpenseDisposer = intercept(this.adminStore, 'operatorExpensePrices', (change: any) => {
            this.setState({
                operatorExpensePrices: change.newValue,
            });
            return change;
        });

        this.regionPriceDisposer = intercept(this.adminStore, 'regionProductPrices', (change: any) => {
            this.setState({
                regionPrices: change.newValue,
            });
            return change;
        });

        this.regionExpenseDisposer = intercept(this.adminStore, 'regionExpensePrices', (change: any) => {
            this.setState({
                regionExpenses: change.newValue,
            });
            return change;
        });
    }

    public clearDisposers() {
        this.operatorDisposer();
        this.operatorPriceDisposer();
        this.operatorExpenseDisposer();
        this.regionPriceDisposer();
        this.regionExpenseDisposer();
        this.wellListDisposer();
    }

    public handleChange = (event: any) => {
        const operator = this.state.operator;

        operator[event.target.name] = event.target.value;

        this.setState({
            isDirty: true,
            operator
        });
    }

    private toggleRegionModal = () => {
        const operator = this.state.operator;
        const selectedRegions = this.setSelectedRegions(operator);
        this.setState({
            operator,
            selectedRegions,
            showRegionModal: !this.state.showRegionModal,
        });
    }

    private toggleList = (key: string) => () => {
        const priceListOpen = this.state.priceListOpen;
        priceListOpen[key] = !priceListOpen[key];
        this.setState({
            priceListOpen
        });
    }

    private togglePriceListModal = () => {
        if (!this.state.showPriceListModal) {
            const productListToMap = DeepCopy(this.state.regionPrices) as IRegionProductPrice[];
            const expenseListToMap = DeepCopy(this.state.regionExpenses) as IRegionExpensePrice[];
            const priceListMapped = productListToMap.map((product) => new IOperatorRegionPrice(product, this.state.operatorId));
            const expenseListMapped = expenseListToMap.map((expense) => new IOperatorRegionExpensePrice(expense, this.state.operatorId));
            // check the most recent operator region price list and override the prices
            const { operatorPrices, operatorExpensePrices } = this.state;
            const mostRecentKey = Object.keys(operatorPrices)[0];
            const operatorPriceListMapped = operatorPrices[mostRecentKey]
                .reduce((acc, price) => {
                    acc[price.productId] = price;
                    return acc;
                }, {} as Record<string, IOperatorRegionPrice>);

            const operatorExpenseListMapped = operatorExpensePrices[mostRecentKey]
                .reduce((acc, price) => {
                    acc[price.expenseId] = price;
                    return acc;
                }, {} as Record<string, IOperatorRegionExpensePrice>);
            priceListMapped.forEach((listItem) => {
                if (operatorPriceListMapped[listItem.productId]) {
                    const foundItem = operatorPriceListMapped[listItem.productId];
                    listItem.price = foundItem.price;
                    listItem.cost = foundItem.cost;
                    listItem.isTaxable = foundItem.isTaxable;
                }
            });
            expenseListMapped.forEach((listItem) => {
                if (operatorExpenseListMapped[listItem.expenseId]) {
                    const foundItem = operatorExpenseListMapped[listItem.expenseId];
                    listItem.price = foundItem.price;
                    listItem.cost = foundItem.cost;
                    listItem.isTaxable = foundItem.isTaxable;
                }
            });
            this.setState({
                modalOpe: expenseListMapped,
                modalOpl: priceListMapped,
                showPriceListModal: !this.state.showPriceListModal
            });
        } else {
            this.setState({
                showPriceListModal: !this.state.showPriceListModal
            });
        }
    }

    private toggleWellListModal = () => {
        if (!this.state.showWellListModal) {
            const wells = new IWellList();
            this.setState({
                showWellListModal: !this.state.showWellListModal,
                wells
            });
        } else {
            this.setState({
                showWellListModal: !this.state.showWellListModal
            });
        }
    }


    public handleChangeRegion = (event: any) => {
        const region = this.state.operator.regions.find(or => or.id === event.target.value);
        if (region) {
            this.adminStore.getOperatorPrices(this.state.operator.id, region.id);
            this.adminStore.getOperatorExpenses(this.state.operator.id, region.id);
            this.adminStore.getWellList(this.state.operator.id, region.id);
            this.adminStore.getRegionProducts(region.id);
            this.adminStore.getRegionExpenses(region.id);
            this.setState({
                region,
                regionId: region.id,
            });
        } else {
            this.adminStore.getOperatorPrices(this.state.operator.id, this.state.region.id);
            this.setState({
                operatorExpensePrices: [],
                operatorPrices: [],
                region: new IRegion(),
                regionId: '',
                wellList: []
            });
        }
    }

    private handleCancel = () => {
        this.setState({
            editing: false,
            modalOPL: new IOperatorRegionPrice()
        });
        this.togglePriceListModal();
    }

    public handleSaveNewWellList = () => {
        const well = this.state.well;
        this.adminStore.updateWellProductList(this.state.operator.id, this.state.region.id, well)
            .then(
                (data: any) => {
                    if (data) {
                        const message = 'Changes To Your Price List Has Been Set';
                        this.MessageStore.addMessage(
                            message,
                            'success'
                        );
                        this.adminStore.getWellList(this.state.operator.id, this.state.region.id);
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        "There Was An Error Setting Your Product List "
                    );
                }
            );
        this.toggleWellListModal();
    }

    private handleSaveNewProductList = () => {
        const message = confirm("Please review your prices before saving. You cannot edit product and EBP prices after you save the new price list.");
        if (message) {
            this.saveProductListLogic();
            this.togglePriceListModal();
        }
    }

    public saveProductListLogic = () => {
        const savePromises = [
            this.adminStore.postNewProductList(this.state.operator.id, this.state.region.id, this.state.modalOpl),
            this.adminStore.postNewExpenseList(this.state.operator.id, this.state.region.id, this.state.modalOpe),
        ];
        Promise.all(savePromises)
            .then(
                (dataPrice: any) => {
                    if (Array.isArray(dataPrice) && dataPrice[0] && dataPrice[1]) {
                        this.MessageStore.addMessage('Changes Have Been Saved', 'success');
                    }
                    this.adminStore.getOperatorPrices(this.state.operator.id, this.state.region.id);
                    this.adminStore.getOperatorExpenses(this.state.operator.id, this.state.region.id);
                },
                (errorPrice: any) => {
                    this.MessageStore.addMessage(
                        errorPrice.toString(),
                        'danger'
                    );
                }
            );

    }

    public handleSaveOperator = () => {
        this.adminStore.saveOperator(this.state.operator)
            .then(
                (data: any) => {
                    if (data) {
                        // if (Object.entries(this.state.operatorPrices).length > 0) {
                        //     this.handleSavePrices();
                        // } else {
                        const operator = this.state.operator;
                        if (operator.id === '') {
                            operator.id = data;
                        }
                        this.setState({ isDirty: false, operator }, () => {
                            this.props.history.push('/admin/operators/' + data);
                            this.MessageStore.addMessage('Changes Have Been Saved', 'success');
                        });
                        // }
                    }
                },
                (error: any) => {
                    this.MessageStore.addMessage(
                        error.toString(),
                        'danger'
                    );
                }
            );
    }

    public saveAssignedRegions = () => {
        const selectedRegions = this.state.regions.filter((reg, index) => this.state.selectedRegions[index] === true);
        const operator = this.state.operator;
        operator.regions = selectedRegions;
        this.adminStore.saveOperator(operator)
            .then(currOperator => {
                if (currOperator) {
                    this.MessageStore.addMessage('Operator Saved.', 'success');
                    this.setState({ isDirty: false }, () => {
                        if (operator.id === '') {
                            operator.id = currOperator;
                            this.props.history.push('/admin/operators/' + currOperator);
                        }
                    });
                } else {
                    this.MessageStore.addMessage('Operator Not Saved.', 'danger');
                }
                this.setState({ showRegionModal: false, operator });
            });
    }



    private handleDateChange = (event: any, index: number) => {
        const copy = this.state.effectiveDate.copyEffectiveDate = event.target.value;
        const productEffectiveDate = this.state.modalOpl;
        const expenseEffectiveDate = this.state.modalOpe;
        productEffectiveDate.forEach(ed => ed.effectiveDate = event.target.value);
        expenseEffectiveDate.forEach(ed => ed.effectiveDate = event.target.value);
        this.setState({
            copy,
            expenseEffectiveDate,
            productEffectiveDate
        });
    }

    private handleWellDateChange = (event: any, index: number) => {
        const effectiveDate = this.state.well;
        effectiveDate[event.target.name] = event.target.value;
        this.setState({
            effectiveDate
        });
    }

    private handlePriceChange = (index: number) => (event: any) => {
        const operatorPrices = this.state.modalOpl;
        operatorPrices[index].price = event.target.value;
        this.setState({ modalOPL: operatorPrices });
    }

    private handleExpensePriceChange = (index: number) => (event: any) => {
        const operatorExpensePrices = this.state.modalOpe;
        operatorExpensePrices[index].price = event.target.value;
        this.setState({ modalOPE: operatorExpensePrices });
    }


    private handleCostChange = (index: number) => (event: any) => {
        const operatorPrices = this.state.modalOpl;
        operatorPrices[index].cost = event.target.value;
        this.setState({ modalOPL: operatorPrices });
    }

    private handleExpenseCostChange = (index: number) => (event: any) => {

        const operatorExpensePrices = this.state.modalOpe;
        operatorExpensePrices[index].cost = event.target.value;
        this.setState({ modalOPE: operatorExpensePrices });
    }

    // Taxable Header Clicks

    private handleTaxableClick = (index: number) => (event: any) => {

        const operatorPrices = this.state.modalOpl;
        operatorPrices[index].isTaxable = !operatorPrices[index].isTaxable;
        this.setState({ modalOPL: operatorPrices });
    }

    private handleExpensesTaxableClick = (index: number) => (event: any) => {
        const operatorExpensePrices = this.state.modalOpe;
        operatorExpensePrices[index].isTaxable = !operatorExpensePrices[index].isTaxable;
        this.setState({ modalOPE: operatorExpensePrices });

    }

    private allOrNoneSelectedRegions = (isAll: boolean) => {
        return allOrNoneSelected(isAll, 'regions', 'selectedRegions', this.state);
    }

    private selectAllOrNoneRegions = (isAll: boolean) => () => {
        const selectedRegions = selectAllOrNone(isAll, this.state.regions);
        this.setState({
            selectedRegions,
        });
    }
    private allOrNoneSelectedPrices = (isAll: boolean, listName: string, propName: string, key: string) => {
        const elements: any[] = this.state[listName][key];
        return allOrNoneSelectedInternalProp(isAll, elements, propName);
    }

    private selectAllOrNonePrices = (value: boolean, listName: string, propName: string, key: string) => () => {
        const elements: any[] = this.state[listName][key];
        selectAllOrNoneInternalProp(value, elements, propName);
        this.setState({ [listName]: this.state[listName] });
    }

    private renderPriceInput = (regionPrice: IOperatorRegionPrice, index: number) => () => {
        return (
            <Input
                type="text"
                name={`regionPrice-${regionPrice.id}`}
                id={`regionPrice-${regionPrice.id}`}
                value={regionPrice.price}
                onChange={this.handlePriceChange(index)}
            />
        );
    }

    private renderExpensePriceInput = (expensePrice: IOperatorRegionExpensePrice, index: number) => () => {
        return (
            <Input
                type="text"
                name={`regionExpensePrice-${expensePrice.id}`}
                id={`regionExpensePrice-${expensePrice.id}`}
                value={expensePrice.price}
                onChange={this.handleExpensePriceChange(index)}
            />
        );
    }

    private renderCostInput = (regionPrice: IOperatorRegionPrice, index: number) => () => {
        return (
            <Input
                type="text"
                name={`regionCost-${regionPrice.id}`}
                id={`regionCost-${regionPrice.id}`}
                value={regionPrice.cost}
                onChange={this.handleCostChange(index)}
            />
        );
    }

    private renderExpenseCostInput = (expensePrice: IOperatorRegionExpensePrice, index: number) => () => {
        return (
            <Input
                type="text"
                name={`regionExpenseCost-${expensePrice.id}`}
                id={`regionExpenseCost-${expensePrice.id}`}
                value={expensePrice.cost}
                onChange={this.handleExpenseCostChange(index)}
            />
        );
    }

    private renderTaxableCheckbox = (regionPrice: IOperatorRegionPrice | IOperatorRegionExpensePrice, index: number) => () => {
        return (
            <div className="multi-select-row">
                <Input onChange={this.handleTaxableClick(index)} checked={regionPrice.isTaxable} type="checkbox" value="" />
            </div>
        );
    }

    private renderExpenseTaxableCheckbox = (regionPrice: IOperatorRegionPrice | IOperatorRegionExpensePrice, index: number) => () => {
        return (
            <div className="multi-select-row">
                <Input onChange={this.handleExpensesTaxableClick(index)} checked={regionPrice.isTaxable} type="checkbox" value="" />
            </div>
        );
    }


    private formatOperatorGroupEmailsData = () => {
        const operatorGroupEmails = this.state.operator.groupEmails;
        const rows = [] as any[];
        operatorGroupEmails.forEach(groupEmail => {
            const tempRow = [
                {
                    content: groupEmail.email
                },
                {
                    content: groupEmail.description,
                }
            ];
            rows.push(tempRow);
        });
        return { headers: this.operatorGroupEmailHeader, rows };
    }

    private handleWellEdit = (index: number) => {
        const well = DeepCopy(this.state.wellList[index]);
        this.setState({
            editing: true,
            rowIndex: index,
            well,
        });
        this.toggleWellListModal();
    }

    private formatOperatorWellData = () => {
        const wells = this.state.wellList;
        const rows = [] as any[];
        wells.forEach(well => {
            const tempRow = [
                {
                    content: well.wellName,
                },
                {
                    content: well.effectiveDate,
                },
                {
                    content: well.wellStatus,
                }
            ];
            rows.push(tempRow);
        });
        return { headers: this.operatorWellsHeader, rows };
    }

    private addOperatorGroupEmail = (addAnother: boolean) => () => {
        const { groupEmail, operator, rowIndex, editingGroupEmail } = this.state;
        if (editingGroupEmail) {
            operator.groupEmails[rowIndex] = groupEmail;
        } else {
            operator.groupEmails.push(groupEmail);
        }
        if (addAnother) {
            this.setState({ groupEmail: new GroupEmail(), operator });
        } else {
            this.setState({ editingGroupEmail: false, groupEmail: new GroupEmail(), groupEmailModal: false, operator });
        }
    }

    private onEditGroupEmail = (index: number) => {
        this.setState({ editingGroupEmail: true, groupEmail: DeepCopy(this.state.operator.groupEmails[index]), groupEmailModal: true, rowIndex: index });
    }

    private toggleGroupEmail = () => {
        this.setState({ groupEmailModal: !this.state.groupEmailModal });
    }

    private onDeleteGroupEmail = (index: number) => {
        const operator = this.state.operator;
        const groupEmail = operator.groupEmails;
        groupEmail.splice(index, 1);
        this.setState({ operator });
    }

    private handleGroupEmailChange = (event: any) => {
        const groupEmail = this.state.groupEmail;
        groupEmail[event.target.name] = event.target.value;
        this.setState({ groupEmail });
    }

    public handleRegionSelect = (index: number) => (event: any) => {
        const selectedRegions = this.state.selectedRegions;
        selectedRegions[index] = !selectedRegions[index];
        this.setState({ selectedRegions });
    }

    public renderRegionCheckBox = (index: number) => () => {
        const checked = this.state.selectedRegions;
        return (
            <div className="multi-select-row">
                <Input
                    type="checkbox"
                    checked={checked[index]}
                    onChange={this.handleRegionSelect(index)}
                />
            </div>
        );
    }
    public formatRegionSelectionData = () => {
        const headers = [
            '',
            'Region Name',
            'State',
        ];

        const rows: any = [];

        this.state.regions.forEach((region, index) => {
            const tempRow = [
                {
                    content: this.renderRegionCheckBox(index),
                    type: 'render'
                },
                {
                    content: region.name,
                },
                {
                    content: region.state,
                }
            ];

            rows.push(tempRow);
        });

        return { headers, rows };
    }

    public toggleDownloadList = () => {
        if (this.state.downloadSelected === 'products') {
            this.setState({
                downloadSelected: 'expenses',
            });
        } else {
            this.setState({
                downloadSelected: 'products',
            });
        }
    }

    private formatNonEditableOperatorProductPriceData = (key: string) => {
        const products = this.state.operatorPrices[key];
        const productsData = products ? products : [];

        const headers = [
            "Product Name",
            "Primary Category",
            "Taxable",
            "Size",
            "Unit",
            "Specific Gravity",
            "Weight",
            "Cost",
            "Price",
        ];

        const rows = productsData.map((value: any, index: any) =>
            [
                {
                    content: value.name,
                },
                {
                    content: value.category,
                },
                {
                    content: value.isTaxable,
                },
                {
                    content: value.size
                },
                {
                    content: value.unit
                },
                {
                    content: value.specificGravity
                },
                {
                    content: value.weight
                },
                {
                    content: value.cost
                },
                {
                    content: value.price
                },
            ]
        );
        return { headers, rows };
    }

    private formatNonEditableOperatorExpensePriceData = (key: string) => {
        const expenses = this.state.operatorExpensePrices[key];
        const expenseData = expenses ? expenses : [];
        const headers = [
            "Name",
            "Type",
            "Taxable",
            "Cost",
            "Price",
        ];
        const rows = expenseData.map((value: any, index: any) =>
            [
                {
                    content: value.name
                },
                {
                    content: value.isRental ? "Rental" : "Service"
                },
                {
                    content: value.isTaxable
                },
                {
                    content: value.cost
                },
                {
                    content: value.price
                }
            ]
        );

        return { headers, rows };
    }

    // @ts-ignore
    private renderNonEditablePriceLists = (key: string, index: any) => {
        if (key !== "1/02/1111") {
            const productData = this.formatNonEditableOperatorProductPriceData(key);
            const expenseData = this.formatNonEditableOperatorExpensePriceData(key);

            return (
                <React.Fragment>
                    <Row>
                        <Col>
                            <h4 className="accordian-h4">
                                <span onClick={this.toggleList(key)}>
                                    <OpenArrow open={this.state.priceListOpen[key]} />
                                    {' '}
                                    {key}
                                    {' '}
                                </span>
                            </h4>
                        </Col>
                    </Row>
                    {
                        this.state.priceListOpen[key] &&
                        <Row>
                            <Col>
                                <DataTable
                                    list={productData}
                                    headerButtons={this.operatorPriceHeaderButtons[key]}
                                    maxHeight='50vh'
                                />
                            </Col>
                        </Row>
                    }
                    {
                        this.state.priceListOpen[key] &&
                        <Row>
                            <Col colspan='10'>
                                <DataTable
                                    list={expenseData}
                                    headerButtons={this.operatorExpenseHeaderButtons[key]}
                                    maxHeight='50vh'
                                />
                            </Col>
                        </Row>

                    }

                </React.Fragment>
            );
        }
    }

    private formatEditableOperatorProductPriceData = () => {
        const products = this.state.modalOpl;

        const headers = [
            "Product Name",
            "Primary Category",
            "Taxable",
            "Size",
            "Unit",
            "Specific Gravity",
            "Weight",
            "Cost",
            "Price",
        ];

        const rows = products.map((value: any, index: any) =>
            [
                {
                    content: value.name
                },
                {
                    content: value.category,
                },
                {
                    content: this.renderTaxableCheckbox(value, index),
                    sortItem: value.isTaxable,
                    type: 'render',
                },
                {
                    content: value.size
                },
                {
                    content: value.unit
                },
                {
                    content: value.specificGravity,
                },
                {
                    content: value.weight,
                },
                {
                    content: this.renderCostInput(value, index),
                    sortItem: value.cost,
                    type: 'render',
                },
                {
                    content: this.renderPriceInput(value, index),
                    sortItem: value.price,
                    type: 'render'
                },
            ]
        );
        return { headers, rows };
    }

    private formatEditableOperatorExpensePriceData = () => {
        const expenses = this.state.modalOpe;
        const headers = [
            "Name",
            "Type",
            "Taxable",
            "Cost",
            "Price",
        ];
        const rows = expenses.map((value: any, index: any) =>
            [
                {
                    content: value.name
                },
                {
                    content: value.isRental ? "Rental" : "Service"
                },
                {
                    content: this.renderExpenseTaxableCheckbox(value, index),
                    sortItem: value.isTaxable,
                    type: 'render',
                },
                {
                    content: this.renderExpenseCostInput(value, index),
                    sortItem: value.cost,
                    type: 'render',
                },
                {
                    content: this.renderExpensePriceInput(value, index),
                    sortItem: value.price,
                    type: 'render'
                }
            ]
        );

        return { headers, rows };
    }


    public render() {
        return (
            <div>
                <Prompt when={this.state.isDirty} message={"Changes have been made.\n\nPress Cancel then Press Save OR Press OK to continue without saving."} />
                <Row>
                    <Col md="6">
                        <FormGroup className="required">
                            <Label>Name</Label>
                            <EInput
                                type="text"
                                name="operatorName"
                                required={true}
                                value={this.state.operator.operatorName}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Billing Address</Label>
                            <EInput
                                type="text"
                                name="billingAddress"
                                value={this.state.operator.billingAddress}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Billing City/State/Zip</Label>
                            <EInput
                                type="text"
                                name="billingCityStateZip"
                                value={this.state.operator.billingCityStateZip}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <FormGroup>
                            <Label>Customer ERP Id</Label>
                            <EInput
                                type="text"
                                name="erpId"
                                value={this.state.operator.erpId}
                                onChange={this.handleChange}
                            />
                        </FormGroup>
                        <Button style={{ marginTop: '5px', marginBottom: '5px' }} color="primary" block={true} onClick={this.toggleRegionModal} disabled={this.state.operator.operatorName === ''}>Assign Operator to Regions</Button>
                        <FormGroup>
                            <Label>Select Region to View/Edit Operator Prices</Label>
                            <Input
                                type="select"
                                name="regionName"
                                required={true}
                                value={this.state.region.id}
                                onChange={this.handleChangeRegion}
                            >
                                <option />
                                {this.state.operator.id !== '' && this.state.operator.regions.map((or, index) =>
                                    <option key={or.id !== '' ? or.id : index} value={or.id}>{or.name}</option>
                                )}
                            </Input>
                        </FormGroup>
                    </Col>
                    <Col md="6" className='align-right'>
                        <DataTable
                            list={this.formatOperatorWellData()}
                            onEdit={this.UserStore.hasGenericPermission('Permissions.Admin.Operators.Update') ? this.handleWellEdit : undefined}
                        />
                    </Col>
                    {
                        this.state.operator.groupEmails.length !== 0 &&
                        <Col md="6" className='align-right'>
                            <DataTable
                                list={this.formatOperatorGroupEmailsData()}
                                onEdit={this.onEditGroupEmail}
                                onNew={{
                                    callback: this.toggleGroupEmail,
                                    text: 'Add New Group Email'
                                }}
                                onDelete={this.onDeleteGroupEmail}
                            />
                        </Col>
                    }
                </Row>


                {
                    this.state.operatorExpensePrices && this.state.operatorExpensePrices && this.state.operatorPrices && Object.entries(this.state.operatorPrices).map(([key, value], index) =>
                        <React.Fragment key={key}>
                            {
                                this.renderNonEditablePriceLists(key, index)
                            }
                        </React.Fragment>
                    )
                }
                <ButtonRow>
                    {
                        this.UserStore.hasGenericPermission('Permissions.Admin.Operators.Update') && this.state.region && this.state.region.id.length > 0 &&
                        <Button color="primary" onClick={this.togglePriceListModal}>
                            Add New Product List
                        </Button>

                    }
                    {
                        (this.state.operator.id === '' ?
                            this.UserStore.hasPermission('Permissions.Admin.Operators.Create')
                            :
                            this.UserStore.hasPermission('Permissions.Admin.Operators.Update'))
                        &&
                        <EButton color="primary" onClick={this.handleSaveOperator}>Save Operator</EButton>
                    }
                </ButtonRow>

                {/* Assign Regions Modal */}
                <Modal isOpen={this.state.showRegionModal} toggle={this.toggleRegionModal} backdrop="static">
                    <ModalHeader toggle={this.toggleRegionModal}>
                        Assign Operator to Regions
                    </ModalHeader>
                    <ModalBody>
                        <DataTable
                            headerButtons={this.operatorRegionHeaderButtons}
                            list={this.formatRegionSelectionData()}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleRegionModal}>Cancel</Button>
                        <Button color="primary" onClick={this.saveAssignedRegions}>Save Assigned Regions</Button>
                    </ModalFooter>
                </Modal>

                {/* Add Group Email Modal */}
                <Modal isOpen={this.state.groupEmailModal} toggle={this.toggleGroupEmail} backdrop="static">
                    <ModalHeader toggle={this.toggleGroupEmail}>
                        Add/Edit Group Email
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Label>Email</Label>
                                <EInput
                                    name="email"
                                    id="email"
                                    value={this.state.groupEmail.email}
                                    onChange={this.handleGroupEmailChange}
                                    data-validation="email"
                                    required={true}
                                />
                                <Label>Description</Label>
                                <EInput
                                    name="description"
                                    id="description"
                                    value={this.state.groupEmail.description}
                                    onChange={this.handleGroupEmailChange}
                                />
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.toggleGroupEmail}>Cancel</Button>
                        <EButton color="primary" onClick={this.addOperatorGroupEmail(false)}>Save</EButton>
                        <EButton color="primary" onClick={this.addOperatorGroupEmail(true)}>Add Another</EButton>
                    </ModalFooter>
                </Modal>


                {/* Create New Price List Modal */}
                <Modal size='xl' isOpen={this.state.showPriceListModal} toggle={this.togglePriceListModal} backdrop="static">
                    <ModalHeader toggle={this.togglePriceListModal}>
                        Create New Product List
                    </ModalHeader>

                    <ModalBody>
                        <Col md="6">
                            <FormGroup className="required">
                                <Label>Effective Date</Label>
                                <EInput
                                    type="date"
                                    name="effectiveDate"
                                    id="effectiveDate"
                                    required={true}
                                    value={this.state.effectiveDate.effectiveDate}
                                    onChange={this.handleDateChange}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <hr />
                        </Col>
                        <Col>
                            <FormGroup className="alternative">
                                <Label>Edit Product List</Label>
                            </FormGroup>
                            <FormGroup>
                                <DataTable
                                    list={this.formatEditableOperatorProductPriceData()}
                                />
                                <DataTable
                                    list={this.formatEditableOperatorExpensePriceData()}
                                />
                            </FormGroup>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <Button className="secondary" onClick={this.handleCancel}>Cancel</Button>
                        {/* { this.state.effectiveDate.effectiveDate && */}
                        <EButton disabled={this.state.effectiveDate.copyEffectiveDate == null} name="save" color="primary" onClick={this.handleSaveNewProductList}>Save Product List</EButton>
                        {/* } */}
                    </ModalFooter>
                </Modal>

                {/* Set Price List To Wells */}
                <Modal isOpen={this.state.showWellListModal} toggle={this.toggleWellListModal} backdrop="static">
                    <ModalHeader toggle={this.toggleWellListModal}>
                        Assign Product List To Well
                    </ModalHeader>

                    <ModalBody>
                        <Col md="6">
                            <FormGroup className="alternative">
                                <Label>Well</Label>
                                <EInput
                                    type="text"
                                    name="well"
                                    id="well"
                                    value={this.state.well.wellName}
                                    disabled={true}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <hr />
                        </Col>

                        <Col md="6">
                            <FormGroup className="alternative">
                                <Label>Copy Current List</Label>
                            </FormGroup>
                            <FormGroup>


                                <EInput
                                    type="select"
                                    name="effectiveDate"
                                    id="effectiveDate"
                                    value={this.state.well.effectiveDate}
                                    onChange={this.handleWellDateChange}
                                >
                                    <option />
                                    {this.state.operatorPrices && Object.keys(this.state.operatorPrices).map((key, index) =>
                                        <option key={key} value={key}>{key}</option>
                                    )}
                                </EInput>
                            </FormGroup>
                        </Col>
                    </ModalBody>
                    <ModalFooter>
                        <Button color="primary" onClick={this.handleSaveNewWellList}>Save Product List To Well</Button>
                    </ModalFooter>
                </Modal>

            </div>
        );
    }
}

export default AdminOperatorDetails;



// WEBPACK FOOTER //
// ./src/Components/Main/Admin/Operators/AdminOperatorDetails.tsx